Storage = require 'lib/storage'

class LastOrganization
  constructor: ->
    @LAST_ORGANIZATION = 'idLastOrganization'
    @NO_ORGANIZATION = 'none'

  set: (idOrganization) ->
    Storage.set @LAST_ORGANIZATION,
      if idOrganization? && idOrganization != ''
        idOrganization
      else
        @NO_ORGANIZATION

  get: ->
    Storage.get(@LAST_ORGANIZATION, null)

module.exports = new LastOrganization()



// WEBPACK FOOTER //
// ./app/scripts/lib/last-organization.coffee